import React from 'react';
import {
  Footprints, Flame, Zap, Salad, HeartHandshake, Droplet, Coffee, Trophy, Megaphone, Award, Crown,
} from 'lucide-react';

const MAP = { Footprints, Flame, Zap, Salad, HeartHandshake, Droplet, Coffee, Trophy, Megaphone, Crown };

export const BadgeIcon = ({ name, className = 'w-6 h-6' }) => {
  const Icon = MAP[name] || Award;
  return <Icon className={className} />;
};
